<template>
    <v-ons-page>
        <div class="content">
            <v-ons-card class="qf-album qf-card-item"   v-for="singleImage in recentImages" v-bind:key="singleImage.id">
                <img :src="baseUrl+'/upload/gallery_file/'+singleImage.id+'?access_token='+token+'&preview=1'" :alt="singleImage.title" :style="{ height: 'calc(82.5vw/'+singleImage.aspect_ratio+')'}">
                <div class="title qf-image-overlay">
                    <span><v-ons-icon icon="fa-images"></v-ons-icon></span> {{singleImage.gallery.title}}
                </div>
                <div class="content" v-if="singleImage.description">
                    {{singleImage.description}}
                </div>
            </v-ons-card>
        </div>
        <qf-spinner :showing="loadingData" message="Updating contents..."></qf-spinner>
    </v-ons-page>
</template>

<script>
    import Api from '@/services/api';
    import QfSpinner from "../shared/QfSpinner";
    export default {
        name: 'DashboardPhotos',
        components: {QfSpinner},
        data() {
            return {
                title: 'Recent files from Galleries',
                recentImages: [],
                token: '',
                baseUrl: process.env.VUE_APP_BASE_URL,
                loadingData: false,
            }
        },
        mounted() {

        },
        methods: {
            aspectCSS(){
                let ratio = 0.5;
                return "width: height(100%/"+ratio+")";
            },
            fetchGalleryImages(){
                this.token = this.$getCookie('access_token');
                let self = this;
                this.loadingData = true;
                setTimeout(function(){
                    if(self.token) {
                        Api().get('dashboard/gallery/6').then(response => {
                            //console.log(response.data);
                            self.recentImages = response.data;
                            self.loadingData = false;
                        }).catch(() => {
                            self.loadingData = false;
                            //console.log(err);
                            //self.$handleReject()
                        });
                    }else{
                        self.loadingData = false;
                    }
                },500);

            }
        },
        computed: {
            currentTabBar(){
                return this.$store.state.shared.homeTabIndex;
            }
        },
        watch: {
            currentTabBar(curTab){
                if(curTab === 1){
                    this.fetchGalleryImages();
                }
            }
        }
    }
</script>

<style scoped>
    .qf-image-overlay {
        display: flex;
        align-items: center;
        width: 100%;
        color: white;
        min-height:48px;
        padding: 10px 15px;
        box-sizing: border-box;
    }
    .qf-image-overlay span{
        margin-right: 15px;
    }
    .qf-album img{
        width: 100%;
        object-fit: cover;
        display: block;
        height: 50vw !important;
        background: #fff;
    }
    .qf-album .card--material__title{margin: 0}
</style>
